import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StaticValues } from '@constant/static-value-constant';

@Component({
  selector: 'app-not-found',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  homePagePath = StaticValues.HOME_PAGE_PATH;

  /*
   * No initialisation logic required. homePagePath is exposed to the template
   * so the "Go home" link can use the canonical home route from StaticValues
   * rather than a hard-coded string.
   */
  constructor() {}
}
